import React from 'react';
import styled, { css } from 'styled-components';
import { ImageWrapperDiv } from '../styles/ImageWrapper';
import add_icon from '../assests/add_icon.png';
import placeholder_image from '../assests/placeholder_image.png';
import heart from '../assests/heart.png';
import delete_image from '../assests/delete_image.png';
import ImageDiv from './ImageDiv'
import cropImage from '../assests/crop.png';

const AddImage = styled.img`
  width: 72px;
  height: 72px;
`;

const InputParentDiv = styled.div`
  width: 72px;
  height: 72px;
  position: absolute;
  /* top: 82px; */
  /* left: 82px; */
  display: inline-block;
  overflow: hidden;
  z-index: 5;
  cursor: pointer;
`;

const InputFile = styled.input`
  width: 72px;
  height: 72px;
  opacity: 0;
  left: 0;
  top: 0;
  position: absolute;
  cursor: pointer;
`;

const HeartParent = styled.div`
  width: 35px;
  height: 35px;
//   top: 125px;
//     left: 30px;
margin-top: -233px;
margin-left: 10px;
  background-color: #ffffff;
  border: solid 3px #9b9b9b;
  position: absolute;
  border-radius: 35px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  visibility: hidden;
  ${props =>
    props.selected &&
    css`
      border: solid 3px #53e03f;
    `}
  ${ImageWrapperDiv}:hover & {
    visibility: visible;
  }
`;

const DeleteImageParent = styled.div`
  width: 35px;
  height: 35px;
  margin-top: -50px;
  margin-left: 194;
  background-color: #ffffff;
  border: solid 3px #eb5252;
  display: flex;
  border-radius: 35px;
  position: absolute;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  visibility: hidden;
  ${ImageWrapperDiv}:hover & {
    visibility: visible;
  }
`;

const CropImageIcon = styled.div`
  width: 35px;
  height: 35px;
  margin-top: -50px;
  margin-left: 190px;
  background-color: #ffffff;
  border: solid 3px #ffffff;
  display: flex;
  border-radius: 35px;
  position: absolute;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  visibility: hidden;
  ${ImageWrapperDiv}:hover & {
    visibility: visible;
  }
`;

const InsideImageStyle = styled.img`
  width: 19px;
  height: 19px;
`;

function ImageWrapper(props) {
  const handleChange = (event) => {
    const file = event.target.files[0];
    props.addImage(URL.createObjectURL(file));
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64String = e.target.result.split(',')[1];
      props.addImage(`data:image/jpeg;base64,${base64String}`, props.photoIndex);
    };

    reader.readAsDataURL(file);
  };

  return (
    <ImageWrapperDiv>
      {
        props.src ? (
          <ImageDiv
            src={props.src.photo} onError={e => { e.target.src = placeholder_image; }}
          />
        ) : (
          <InputParentDiv>
            <AddImage src={add_icon} />
            <InputFile
              type="file"
              onChange={e => handleChange(e)}
              placeholder=""
              accept=""
            />
          </InputParentDiv>
        )
      }
      {
        props.src ? (
          <HeartParent
            selected={props.src.selected}
            onClick={() => props.selectedImage(props.src.photo_id)}
          >
            {props.src.selected ? <InsideImageStyle src={heart} /> : null}
          </HeartParent>
        ) : null
      }
      {
        props.src && props.canDelete ? (
          < DeleteImageParent onClick={() => props.deleteImage(props.photoIndex)}>
            <InsideImageStyle src={delete_image} />
          </DeleteImageParent>
        ) : null
      }
      {
        props.src && props.showImageCrop ? (
          < CropImageIcon onClick={() => {
            props.showImageCrop(props.src.photo)
            localStorage.setItem('photoIndex', props.photoIndex)
          }}>
            <InsideImageStyle src={cropImage} />
          </CropImageIcon>
        ) : null
      }
      {
        !props.src ? (
          <InputParentDiv >
            <AddImage src={add_icon} />
            <InputFile
              type="file"
              onChange={e => handleChange(e)}
              placeholder=""
              accept=""
            />
          </InputParentDiv>
        ) : null
      }

    </ImageWrapperDiv >
  );
};

export default ImageWrapper;
